import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div>
      <section className="py-16 md:py-24" style={{ backgroundColor: '#FAFAFA' }}>
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <h1
            className="text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-bold mb-8"
            style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
            data-testid="terms-heading"
          >
            Terms of Service
          </h1>
          <p className="text-sm mb-8" style={{ color: '#94A3B8' }}>
            Last updated: April 2026
          </p>

          <article className="space-y-8" data-testid="terms-content">
            <div
              className="p-6 border-l-4"
              style={{ borderColor: '#FF5722', backgroundColor: '#FFF4E6' }}
            >
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                Dhanamm (dhanamm.com) is partnered with Angel One for Demat account openings, Mutual Funds, Insurance, and other financial products. We are not a SEBI registered company and we do not provide any advisory from our side. We only work as a middlemen who transit Angel One advisories, resolve your technical app related issues such as buying, selling, profile updates, etc. Our Sub Broker code is <strong style={{ color: '#0A0F1A' }}>MNUL</strong> and we use Angel One's SEBI license and work along with Angel One.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                1. Acceptance of Terms
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                By accessing and using this website (dhanamm.com), you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do not use our website or services.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                2. Nature of Services
              </h2>
              <p className="text-base leading-relaxed mb-3" style={{ color: '#475569' }}>
                Dhanamm operates as an authorised sub-broker under Angel One (Sub Broker Code: MNUL). Our services include:
              </p>
              <ul className="space-y-2 ml-4">
                <li className="text-base" style={{ color: '#475569' }}>Facilitating Demat and Trading account opening through Angel One.</li>
                <li className="text-base" style={{ color: '#475569' }}>Assisting with Mutual Funds, Insurance, and other financial product applications.</li>
                <li className="text-base" style={{ color: '#475569' }}>Providing technical support for app-related queries including buying, selling, and profile updates.</li>
                <li className="text-base" style={{ color: '#475569' }}>Transmitting advisories and research provided by Angel One to clients.</li>
              </ul>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                3. No Investment Advisory
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                Dhanamm does not provide any investment advisory, stock tips, portfolio management, or financial planning services. We are not registered with SEBI as an Investment Adviser or Research Analyst. Any market-related content on this website is for educational and informational purposes only and should not be considered as investment advice. All advisory services, if any, are provided directly by Angel One under their SEBI registration.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                4. User Responsibilities
              </h2>
              <ul className="space-y-2 ml-4">
                <li className="text-base" style={{ color: '#475569' }}>You must provide accurate and complete information during the account opening process.</li>
                <li className="text-base" style={{ color: '#475569' }}>You are responsible for maintaining the confidentiality of your trading account credentials.</li>
                <li className="text-base" style={{ color: '#475569' }}>You agree to use our website and services only for lawful purposes.</li>
                <li className="text-base" style={{ color: '#475569' }}>All investment decisions are made solely at your own risk and discretion.</li>
              </ul>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                5. Third-Party Services
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                Our website may contain links to Angel One and other third-party services. We are not responsible for the content, privacy practices, or terms of any third-party websites. Your use of Angel One's trading platform is governed by Angel One's own terms and conditions.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                6. Intellectual Property
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                All content on this website, including text, graphics, logos, and design, is the property of Dhanamm or its content suppliers and is protected by applicable intellectual property laws. You may not reproduce, distribute, or modify any content without prior written consent.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                7. Limitation of Liability
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                Dhanamm shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use of our website or services. Stock market investments are subject to market risks. We do not guarantee any returns or profits from trading or investing.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                8. Modifications
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                We reserve the right to modify these Terms of Service at any time. Changes will be effective upon posting on this page. Continued use of the website after changes constitutes acceptance of the revised terms.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                9. Governing Law
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                These terms shall be governed by and construed in accordance with the laws of India. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in Bangalore, Karnataka.
              </p>
            </div>

            <div>
              <h2
                className="text-2xl font-semibold mb-4"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
              >
                10. Contact Us
              </h2>
              <p className="text-base leading-relaxed" style={{ color: '#475569' }}>
                For any questions regarding these Terms of Service, please contact us at:
              </p>
              <p className="text-base mt-2" style={{ color: '#475569' }}>
                <strong style={{ color: '#0A0F1A' }}>Email:</strong> angeloneblr@gmail.com<br />
                <strong style={{ color: '#0A0F1A' }}>Phone:</strong> +91 99023 00787<br />
                <strong style={{ color: '#0A0F1A' }}>Angel One SEBI Registration No:</strong> 1N2000161534<br />
                <strong style={{ color: '#0A0F1A' }}>Address:</strong> AECS Layout, A Block, Singasandra, Bangalore 560068
              </p>
            </div>
          </article>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
